var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "li",
    {
      staticClass: "tree-node",
      class: _vm.nodeClass,
      attrs: { role: "treeitem", "data-id": _vm.node.id },
      on: {
        mousedown: function ($event) {
          $event.stopPropagation()
          return _vm.handleMouseDown.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "tree-content",
          style: [
            _vm.options.direction == "ltr"
              ? { "padding-left": _vm.padding }
              : { "padding-right": _vm.padding },
          ],
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.select.apply(null, arguments)
            },
          },
        },
        [
          _c("i", {
            staticClass: "tree-arrow",
            class: [
              {
                expanded: _vm.node.states.expanded,
                "has-child": _vm.node.children.length || _vm.node.isBatch,
              },
              _vm.options.direction,
            ],
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.toggleExpand.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _vm.options.checkbox
            ? _c("i", {
                staticClass: "tree-checkbox",
                class: {
                  checked: _vm.node.states.checked,
                  indeterminate: _vm.node.states.indeterminate,
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.check.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              ref: "anchor",
              staticClass: "tree-anchor",
              attrs: { tabindex: "-1" },
              on: {
                focus: _vm.onNodeFocus,
                dblclick: function ($event) {
                  return _vm.tree.$emit("node:dblclick", _vm.node)
                },
              },
            },
            [_c("node-content", { attrs: { node: _vm.node } })],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "l-fade" } }, [
        _vm.hasChildren() && _vm.node.states.expanded
          ? _c(
              "ul",
              { staticClass: "tree-children" },
              _vm._l(_vm.visibleChildren, function (child) {
                return _c("node", {
                  key: child.id,
                  attrs: { node: child, options: _vm.options },
                })
              }),
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }